// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoriteStarLabel-module__container--2V8ji","text":"FavoriteStarLabel-module__text--2oWN2","icon":"FavoriteStarLabel-module__icon--20ITM"};